import type { Content } from '~/i18n/schema';

export type NavLink = Content['nav']['links'][number];

export interface NavFlags {
  /** When false, the Portfolio (Realizacje) link is omitted. */
  portfolio: boolean;
}

/**
 * Filter the nav link list according to active build-time feature flags.
 * Pure function — no DOM or window access. Suitable for SSR.
 *
 * Tested against both flag values; production callers pass the build-time
 * `__FEATURE_PORTFOLIO__` constant which constant-folds the conditional.
 */
export function visibleNavLinks(links: readonly NavLink[], flags: NavFlags): NavLink[] {
  return links.filter((link) => {
    if (link.id === 'portfolio') return flags.portfolio;
    return true;
  });
}
